export default function () {
  return {
    countCells: 8,
    massive: [
      {
        dataField: 'kcp',
        cols: 2,
        rows: 2,
        order: 0,
        class: 'd-flex flex-row align-center justify-start  ',
        variable: false,
        text: 'УГСН (НПС)',
        headerClass: 'header-table-cell align-end table-header-info',
        headerStyles: `justify-content: flex-start; min-width: 100px`,
      },
      {
        dataField: '2',
        cols: 2,
        rows: 1,
        order: 5,
        variable: false,
        headerClass: 'text-center border-bottom-zero',
        text: 'КЦП прошлых периодов\n',
        headerStyles: `justify-content: flex-start; min-width: 100px`,
      },
      {
        dataField: 'pv',
        cols: 1,
        rows: 2,
        order: 2,
        variable: true,
        headerClass: 'header-table-cell table-header-info',
        text: `Потребность в&nbsp;подготовке кадров на долгосрочный период`,
        headerStyles: `padding: 8px 15px 8px 0 !important; `,
      },
      {
        dataField: 'startValue',
        cols: 1,
        rows: 2,
        order: 12,
        variable: true,
        headerClass: ' header-table-cell table-header-info',
        class: '',
        text: 'Прогнозируемый объем КЦП на 2025/26 учебный год',
        headerStyles: `padding: 8px 15px 8px 0 !important`,
      },
      {
        dataField: 'maxPp',
        cols: 1,
        rows: 2,
        order: 13,
        variable: true,
        class: ``,
        headerClass: ' header-table-cell table-header-info',
        headerStyles: `padding: 8px 10px 8px 0 !important`,
        text: 'Максимально возможный прием образовательными организациями региона',
      },
      {
        dataField: 'value',
        cols: 1,
        rows: 2,
        order: 14,
        variable: true,
        headerClass: ' header-table-cell table-header-info',
        styles: 'justify-content: unset;',
        text: 'Предложение Субъекта Российской Федерации',
        headerStyles: `padding: 8px 15px 8px 0 !important; `,
      },
      {
        dataField: 'kcp23',
        cols: 1,
        rows: 1,
        order: 7,
        variable: true,
        class: ' ',
        headerClass: 'table-header-info',
        headerStyles: `justify-content: flex-start`,
        text: '2023',
      },
      {
        dataField: 'kcp24',
        cols: 1,
        rows: 1,
        order: 8,
        variable: true,
        class: ' ',
        headerClass: ' table-header-info',
        text: '2024',
      },
    ],


    rowsMassive: [ // строки таблицы
      {
        dataField: 'kcp',
        cols: 2,
        rows: 1,
        // text: 'УГСН (НПС)',
        class: 'd-flex flex-row align-center justify-start  ',
        headerClass: 'header-table-cell align-end ',
        headerStyles: `min-width: 305px; justify-content: flex-start;`,
        order: 0,
        variable: true,
        template: r => r?.kcpGroup.code + ' ' + r?.kcpGroup.name
      },
      {
        dataField: 'kcp23',
        cols: 1,
        rows: 1,
        order: 7,
        variable: true,
        class: ' ',
        headerClass: '',
        headerStyles: `justify-content: flex-start`,
        // text: '2022',
        template: (r) => this.$scripts.TableJs.formatValueInCell(r.kcp23, 0)
      },
      {
        dataField: 'kcp24',
        cols: 1,
        rows: 1,
        order: 8,
        variable: true,
        class: ' ',
        headerClass: ' ',
        // text: '2023 ',
        template: (r) => this.$scripts.TableJs.formatValueInCell(r.kcp24, 0)
      },
      {
        dataField: 'pv',
        cols: 1,
        rows: 1,
        order: 2,
        variable: true,
        styles: 'justify-content: unset;',
        // text: `Потребность в подготовке кадров на долгосрочный период`,
        template: (r) => this.$scripts.TableJs.formatValueInCell(r.pv, 0)
      },
      // {
      //   dataField: 'pp',
      //   cols: 1,
      //   rows: 1,
      //   order: 10,
      //   variable: true,
      //   class: ``,
      //   styles: 'justify-content: unset;',
      //   template: (r) => this.$scripts.TableJs.formatValueInCell(r.pp, 0)
      // },
      // {
      //   dataField: 'dj',
      //   cols: 1,
      //   rows: 1,
      //   order: 11,
      //   variable: true,
      //   class: ``,
      //   styles: 'justify-content: unset;',
      //   template: r => r?.dj && !Number.isNaN(r?.dj * 100) ? (r?.dj * 100).toFixed(2) + '%' : 'н.д.'
      // },
      {
        dataField: 'startValue',
        cols: 1,
        rows: 1,
        order: 12,
        variable: true,
        headerClass: ' header-table-cell ',
        class: '',
        headerStyles: `padding: 8px 15px 8px 0 !important`,
        styles: 'justify-content: unset;',
        template: (r) => this.$scripts.TableJs.formatValueInCell(r.startValue, 0)
      },
      {
        dataField: 'maxPp',
        cols: 1,
        rows: 1,
        order: 13,
        variable: true,
        class: ``,
        styles: 'justify-content: unset;',
        template: (r) => this.$scripts.TableJs.formatValueInCell(r.maxPp, 0)
      },
      {
        dataField: 'stage2Value',
        cols: 1,
        rows: 1,
        order: 14,
        variable: true,
        headerClass: ' header-table-cell',
        styles: 'justify-content: unset;',
        headerStyles: `padding: 8px 15px 8px 0 !important; `,
      },
    ]
  }
}